<template>
  <div>
    <AlertComponent :alert="this.alert"></AlertComponent>
    <editarPerfil :alert="this.alert" v-if="this.render" :cadastro="true" :conta="this.usuario"></editarPerfil>
    <v-icon class="custom-loader" v-if="this.loading">cached</v-icon>
  </div>
</template>

<script>
import FormUsuario from "@/components/conta/usuario/formUsuario/FormUsuario.vue";
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
import inputFile from "@/components/shared/inputFile/InputFile.vue";
import editarPerfil from "@/pages/loggedArea/editarPerfil/EditarPerfil.vue";
import AlertComponent from "@/components/shared/alertMessage/AlertMessage.vue";
import GravatarService from "@/domain/gravatar/GravatarService.js";
import AlertMessage from "@/domain/alertMessage/AlertMessage.js";
export default {
  components: {
    inputFile: inputFile,
    FormUsuario: FormUsuario,
    editarPerfil: editarPerfil,
    AlertComponent: AlertComponent
  },
  data() {
    return {
      usuario: {},
      validPass: true,
      show2: false,
      show3: false,
      pass1: "",
      pass2: "",
      loading: true,
      passwordRules: [
        v => !!v || "Campo é obrigatório",
        v =>
          (!!v && v.length <= 25) || "Precisa conter menos que 25 caracteres",
        v => (!!v && v.length >= 5) || "Precisa conter mais que 5 caracteres"
      ],
      currentItem: "",
      render: false,
      tabs: [
        {
          title: "Minha senha"
        }
      ],
      alert: new AlertMessage()
    };
  },
  beforeCreate: async function() {
    await this.$nextTick(async function() {
      let token = this.$router.currentRoute.params.token;
      this.service = new UsuarioService(this.$http);
      await this.service
        .getUsuarioByToken(token)
        .then(resp => {
          this.loading = false;
          if (resp.ok) {
            this.usuario = resp.body;
            this.usuario["id_usuario"] = resp.body._id;
            this.render = true;
            return resp.body.email;
          } else {
            this.alert.snackAlert();
            this.alert.snack.text = "Pendência de cadastro não localizada.";
            this.alert.snack.show = true;
            let router = this.$router;
            setTimeout(function() {
              router.push("/");
            }, 4000);
          }
        })
        .then(async email => {
          if (email) {
            this.service = new GravatarService(this.$http);
            await this.service.getGravatar(email).then(
              success => {
                this.usuario["gravatarProfile"] = success;
              },
              failed => {}
            );
          }
        });
    });
  },
  updated: function() {},
  computed: {},
  methods: {
    salvarDados() {
      let envDados = false;
      if (this.$refs.formPass.validate()) {
        if (this.pass1 != this.pass2) {
          this.passwordRules.push(function diferentes(v) {
            return "Senhas diferem uma da outra.";
          });
          this.$refs.pass2.validate();
          if (
            this.passwordRules[this.passwordRules.length - 1].name.length != 0
          ) {
            this.passwordRules.pop();
          }
        } else {
          envDados = true;
        }
      }
      if (envDados) {
        alert("Implementar logica");
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  text-decoration: none;
  color: #42b983;
}
.iconCloud {
  transform: rotate(180deg);
}
#panelEmpresa {
  padding: 30px 0;
  background: #e3f2fd;
}
#panelEmpresa h1 {
  font-family: "Quicksand", sans-serif;
}

#containerTab div.v-tabs__container {
  margin-left: 35px !important;
}
.v-tabs__container {
  background-color: #fafafa !important;
}
.v-tabs__bar {
  padding-top: 35px !important;
}
.v-card__text {
  padding-top: 0 !important;
}
#tabOption.active {
  background-color: white;
}
#infoConsulta {
  text-align: center;
  position: absolute;
  right: 2%;
  border: 2px solid #cbcbcb;
  padding: 0 1.6%;
  height: 44px;
  border-radius: 6px;
}

#infoConsulta small {
  font-weight: bold;
  font-size: 66%;
}
#infoConsulta div {
  margin-top: -6px;
}
#infoConsulta i {
  font-size: 16px;
}
#infoConsulta span {
  font-size: 86%;
}
div#infoConsulta.cte {
  top: 9.9%;
  background-color: white;
}
.descTable {
  background-color: rgb(0, 150, 136) !important;
  margin: 0 0 39px 0px;
}
.descTable.cte {
  margin: 0 0 50px 0px;
}
.cardPerfil {
  margin-top: 39px;
}
.cardPerfil-title {
  background-color: lightgrey;
  padding: 15px;
  border-radius: 11px 11px 0 0;
  font-weight: 600;
  color: #5d5d5d;
}
.cardPerfil-img {
  width: 15%;
  display: inline-block;
  text-align: center;
}
.cardPerfil-img img {
  border-radius: 50%;
  width: 72px;
  height: 72px;
  text-align: center;
}

.cardPerfil-body {
  background-color: white;
  padding: 20px 0px 20px 15px;
}
.custom-loader {
  position: absolute;
  left: 47%;
  top: 44%;
  -webkit-transform: translate(-50%, -50%);
  font-size: 100px;

  background: -webkit-linear-gradient(bottom, #009688, #35d6c7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.custom-loader {
  animation: loader 1s infinite;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style> 



// WEBPACK FOOTER //
// src/pages/guestArea/novoUsuario/NovoUsuario.vue